export default "__VITE_ASSET__Bk2m2_yT__"